import {RealizeOrderList} from "./RealizeOrderList";
import {RealizeOrderEdit} from "./RealizeOrderEdit";
import {RealizeOrderCreate} from "./RealizeOrderCreate";

export default {
    list: RealizeOrderList,
    create: RealizeOrderCreate,
    edit: RealizeOrderEdit
};
